/*
Color Palette is referenced to IBM Carbon Design System
Todo: Replace this file with officially refactored color palette in toolkit whenever it's ready
*/
const colorPalette = {
	red: {
		font: '#a51920',
		background: '#fcd0d3',
	},
	magenta: {
		font: '#a11950',
		background: '#ffcfe1',
	},
	purple: {
		font: '#6e32c9',
		background: '#e6d6ff',
	},
	blue: {
		font: '#054ada',
		background: '#c9deff',
	},
	cyan: {
		font: '#0058a1',
		background: '#b3e6ff',
	},
	teal: {
		font: '#006161',
		background: '#92eeee',
	},
	green: {
		font: '#10642a',
		background: '#9deeb2',
	},
	gray: {
		font: '#565656',
		background: '#dcdcdc',
	},
	coolgray: {
		font: '#50565b',
		background: '#d5d9e0',
	},
	warmgray: {
		font: '#595555',
		background: '#e0dbda',
	},
	black: {
		font: '#ffffff',
		background: '#171717',
	},
	default: {
		font: '#343334',
		background: '#ffffff',
	},
};

export default colorPalette;
